import { StyledButton } from '../../../components/StyledButton';
import { Container, Content } from './styles';
import { MdClose } from 'react-icons/md';

interface IProps {
  title: string;
  text?: string;
  buttonText: string;
  setModal: (value: boolean) => void;
  callActions?: Array<() => void>;
  children: string | JSX.Element | JSX.Element[];
  showButton?: boolean;
  denyButon?: boolean;
}

const CustomModal = ({
  title,
  text,
  buttonText,
  setModal,
  callActions,
  children,
  showButton = true,
  denyButon = false,
}: IProps) => (
  <Container>
    <Content>
      <div className="icon" onClick={() => setModal(false)}>
        <MdClose size={24} color="#B3B3B3" />
      </div>
      <div className="title">{title && <p>{title}</p>}</div>

      <div className="body">
        <div className="text">
          <p>{text}</p>
        </div>

        {children}

        {showButton && (
          <div className="buttons">
            {denyButon && (
              <StyledButton
                className="cancel"
                text="Cancelar"
                backgroundColor="red"
                onClick={() => {
                  setModal(false);
                }}
                fullWidth
              />
            )}
            <StyledButton
              text={buttonText}
              backgroundColor="blue"
              onClick={() => {
                setModal(false);
                callActions && callActions.map((action) => action());
              }}
              fullWidth
            />
          </div>
        )}
      </div>
    </Content>
  </Container>
);

export { CustomModal };
